import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import type { DashboardStats } from "../../types/dashboard";
import { formatCompactCount, formatCompactCurrency } from "../../utils/format";
import { getQuickStatsLifetimeNote } from "./dashboardCopy";

interface QuickStatsPanelProps {
  stats: DashboardStats | null | undefined;
  activeMovies: number;
}

interface Tile {
  label: string;
  value: string;
  caption: string;
  color: string;
}

const QuickStatsPanel: React.FC<QuickStatsPanelProps> = ({
  stats,
  activeMovies,
}) => {
  const lifetime = getQuickStatsLifetimeNote();

  const tiles: Tile[] = stats
    ? [
        {
          label: "Total Revenue",
          value: formatCompactCurrency(stats.totalRevenue),
          caption: "selected period",
          color: "warning",
        },
        {
          label: "Total Bookings",
          value: formatCompactCount(stats.totalBookings),
          caption: "selected period",
          color: "success",
        },
        {
          label: "Pending Bookings",
          value: formatCompactCount(stats.pendingBookings),
          caption: "selected period",
          color: "info",
        },
        {
          label: "Total Cinemas",
          value: formatCompactCount(stats.totalCinemas),
          caption: lifetime,
          color: "primary",
        },
        {
          label: "Active Movies",
          value: formatCompactCount(activeMovies),
          caption: lifetime,
          color: "secondary",
        },
        {
          label: "Total Users",
          value: formatCompactCount(stats.totalUsers),
          caption: lifetime,
          color: "dark",
        },
      ]
    : [];

  return (
    <Col xs={12} className="mb-3">
      <Card>
        <Card.Header>
          <h5 className="mb-0">Quick Stats</h5>
        </Card.Header>
        <Card.Body>
          <Row className="gx-3 gy-3">
            {tiles.map((tile) => (
              <Col
                key={tile.label}
                xs={6}
                sm={4}
                md={4}
                lg={2}
                xl={2}
                className="mb-2"
              >
                <div
                  className={`text-${tile.color} fw-bold`}
                  style={{ fontSize: 22, lineHeight: 1.1 }}
                >
                  {tile.value}
                </div>
                <div className="text-muted" style={{ fontSize: 13 }}>
                  {tile.label}
                </div>
                <div className="text-muted" style={{ fontSize: 11 }}>
                  {tile.caption}
                </div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default QuickStatsPanel;
